import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Button,
  Typography,
  Grid,
} from '@material-ui/core';
import {
  CloseOutlined as CloseIcon,
  FileCopy as CopyIcon,
} from '@material-ui/icons';
import { MyPATIconButton, MyPATDialog } from '../../common';

import ContentData from '../types/ContentData';
import contentService from '../services/contentService';

const styles = (theme:Theme) => createStyles({
  testLabel: {
    ...theme.typography.caption,
    color: theme.palette.primary.main,
    display: 'inline-block',
    marginLeft: theme.spacing.unit,
    padding: `0 ${theme.spacing.unit}px`,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 2,
  },
  testMarks: {
    display: 'inline-block',
    marginRight: theme.spacing.unit,
  }
});

//@ts-ignore
interface Props extends WithStyles<typeof styles> {
    classes: any,
    contentList: ContentData[]
    isDeleteDialogOpen: boolean,
    onDeleteConfirmed: Function,
}
interface States {
  isDeleteDialogOpen: boolean,
  isPreviewTestTempleteOpen: boolean,
}

class ContentDeleteConfirm extends Component<Props,States> {
  state = {
    isDeleteDialogOpen: false,
    isPreviewTestTempleteOpen: false,
  };

  constructor(props: Props){
    super(props)

    this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);
  }

  onDeleteConfirmed(isDeleted: boolean){
    if(isDeleted){
      contentService.remove(this.props.contentList).then(c => {
        this.props.onDeleteConfirmed(isDeleted);
      })
    }else{
      this.props.onDeleteConfirmed(isDeleted);
    }
  }

  getContentIds() {
    const {contentList} = this.props
    return contentList.map(content => content.contentId).join(',')
  }

  render(){
    const { classes, isDeleteDialogOpen, contentList } = this.props;

    return(
      <div>
        <MyPATDialog
          dialogOpen={this.props.isDeleteDialogOpen}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: 'sm',
          }}
          customButtonVariant="withoutBorderCloseIcon"
          customDialogActions={
            <>
            {
                contentList && contentList.length > 0 && (
                    <Button color="primary" onClick={()=> { this.onDeleteConfirmed(true) }}>Delete</Button>
                )
            }
              
              <Button
                variant="contained" color="primary"
                onClick={()=> { this.onDeleteConfirmed(false) }}>
                Cancel
              </Button>
            </>
          }
        >
          <Typography variant="body1">
            {
                (!contentList || contentList.length == 0) && (
                    <strong>No content selected for delete</strong>
                )
            }
            {
                contentList && contentList.length > 0 && (
                    <strong>Are you sure you want to delete "{this.getContentIds()}" permanently?</strong>
                    /* TODO remove comment */
                    // <strong>Are you sure you want to delete "{contentList.length} content" permanently?</strong>
                )
            }
          </Typography>
        </MyPATDialog>
      </div>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(ContentDeleteConfirm);